import { ReactNode, useEffect } from 'react'
import { Amplify } from '@aws-amplify/core'
import { useRouter } from 'next/router'

import { federatedSignInAgain } from 'store/partials/auth/authSlice'
import { getAmplifyConfig } from 'utils/amplify/config'

let amplifyConfigured = false

const AuthProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const router = useRouter()

  useEffect(() => {
    if (router.query.error_description?.toString()?.startsWith('Already found an entry for username ')) {
      federatedSignInAgain(undefined, 'Vipps')
    } else if (router.query.error_description?.toString()?.startsWith('User cancelled the login')) {
      // If we pressed cancel in Vipps - redirect to login page again
      router.push('/login')
    }

    if (!amplifyConfigured) {
      Amplify.configure(getAmplifyConfig())
      amplifyConfigured = true
    }
  })

  return <>{children}</>
}

export default AuthProvider
